'use strict';

let processInclude = require('base/util');

$(document).ready(function () {
  const isMargiela = document.body.dataset.sitebrand === "Margiela";

  // Revamp has the account drawer (#account-sheet) present on every page, so we add it to the selector
  const selector = isMargiela
    ? '#login-page, #guest-login-page, #account-passwordreset, #account-setnewpassword, #account-passwordupdatejourneyfrompm, #account-passwordupdatejourneyfromcampaign, #login-show, #account-sheet'
    : '#login-page, #guest-login-page, #account-sheet';
    
  if ($(selector).length > 0) {
    processInclude(require('./login/login'));
  }

  // MARG-772: Password reset token handling
  if (isMargiela) {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('password-reset-token')) {
      $.spinner().start();
      const result = $('<div></div>');
      const resetSelector = '#new-password-sheet';
      const newPasswordUrl= $('#account-sheet .mm-account-container').data('url');

      result.load(newPasswordUrl + '?'
        + $.param({ token: searchParams.get('password-reset-token'), journey: searchParams.get('journey') })
        + ' ' + resetSelector, (response, status, xhr) => {
        $.spinner().stop();
        
        if (status === 'error') return;

        if (xhr.statusCode === 302) {
          $.spinner().start();
          result.load(xhr.getResponseHeader('Location') + '?'
            + $.param({ journey: searchParams.get('journey') })
            + ' ' + resetSelector, (response2, status2, xhr2) => {
            $.spinner().stop();

            if (status2 === 'error') return;

            $(document.body).append(result.contents());
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('MMSheet:open', { detail: { id: 'new-password-sheet' } }));
            }, 100);
            processInclude(require('./login/login'));
          });
          return;
        }

        // Token invalido/scaduto: SetNewPassword risponde 302 verso Account-PasswordReset,
        // jQuery lo segue in trasparenza e la pagina risultante non contiene la sheet.
        // Fallback: riapri la account-sheet direttamente sul form di reset password.
        if (result.find(resetSelector).length === 0) {
          document.dispatchEvent(new CustomEvent('MMAccountSheet:openReset'));
          return;
        }

        $(document.body).append(result.contents());
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('MMSheet:open', { detail: { id: 'new-password-sheet' } }));
        }, 100);
        processInclude(require('./login/login'));
      });
    }
  }
});

$(document).on('login-dropdown:openRemote login-modal:openRemote', function (e) {
  processInclude(require('./login/login'));
});
